import router from '@/navigation'
import urls from '@/navigation/urls'
import { IEquipment } from '@/pages/Equipment/equipment.types'
import equipmentUtils from '@/pages/Equipment/equipment.utils'
import { IUserRouteHistory } from '@/pages/User/user.types'
import userUtils from '@/pages/User/user.utils'
import { IUser } from '@/pages/Users/users.types'
import { RouteObject } from 'react-router-dom'

const findRouteByPath = (routes: RouteObject[], path: string) => {
  for (const route of routes) {
    if (route.path === path) return route
    if (route.children) {
      const found = findRouteByPath(route.children, path)
      if (found) return found
    }
  }
  return null
}

const mapHistoryRoutesToTitles = (historyPaths: IUserRouteHistory[], equipmentList: IEquipment[], users: IUser[]) => {
  const routeTitleList = historyPaths.map(({ routeName }) => {
    switch (true) {
      case routeName.includes(urls.lifts):
        const liftId = +routeName.split('/').at(-1)
        const equipment = equipmentList.find((item) => item.id === liftId)
        if (!equipment) return null
        return { routeName, title: equipmentUtils.getEquipmentAddress(equipment.location) }
      case routeName.includes(urls.myOrganization) && !isNaN(+routeName.split('/').at(-1)):
        const userId = +routeName.split('/').at(-1)
        const user = users.find((item) => item.id === userId)
        if (!user) return null
        return { routeName, title: userUtils.getFullName(user.userInfo) }
      default:
        const route = findRouteByPath(router.routes, routeName)

        if (Boolean(route) && Boolean(route.handle?.crumb)) {
          const crumb = route.handle?.crumb
          const title = typeof crumb === 'function' ? crumb({ pathname: routeName }) : crumb
          return { routeName, title: title || routeName }
        }

        return null
    }
  })

  return routeTitleList.filter((item) => Boolean(item))
}

const routesHistoryWidgetUtils = { mapHistoryRoutesToTitles }

export default routesHistoryWidgetUtils
